import React from 'react';

// === Components === //
import Container from '@components/common/Container';
import ButtonLink from '@components/common/ButtonLink';

// === Styles === //
import styled from '@emotion/styled';
import { dimensions } from '@styles';

// === Types === //
import { Variant } from '@content/types/layout';

const PublicationsItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 640px;
  margin-bottom: 7px;
`;

const PublicationsHeader = styled.h4`
  margin-bottom: 0;
`;

const PublicationsSubHeader = styled.p`
  margin-bottom: 0;
  display: inline-block;
  margin-bottom: 12px;
`;

interface PublicationsItemProps {
  url: string;
  urlLabel: string;
  title: string;
  subTitle: string;
  id: string;
  variant: Variant;
}

const PublicationsItem = ({
  url,
  urlLabel,
  title,
  subTitle,
  id,
  variant,
}: PublicationsItemProps) => {
  return (
    <Container>
      <PublicationsItemWrapper>
        <PublicationsHeader>{title}</PublicationsHeader>
        <PublicationsSubHeader>
          <span>{subTitle}</span>
          <span> {id}</span>
        </PublicationsSubHeader>
        <div>
          <ButtonLink type="external" icon="chevron" variant={variant} link={url}>
            {urlLabel}
          </ButtonLink>
        </div>
      </PublicationsItemWrapper>
    </Container>
  );
};

export default PublicationsItem;
